import { colors } from "src/config/colors";
import { StyledSx } from "src/types/StyledSx";

const CardSliderStyle: StyledSx = {
  root: {
    border: "1px solid #DEDFE3",
    boxSizing: "border-box",
    ":hover": {
      border: `1px solid ${colors.yellow}`,
    },
  },
  cardContent: {
    paddingLeft: "22px",
    paddingRight: "22px",
  },
  boxContent: {
    marginBottom: "13px",
  },
  discountText: {
    backgroundColor: colors.gray,
    borderRadius: "3px",
    ":hover": {
      backgroundColor: "#F7E64D",
    },
  },
  avatar: {
    backgroundColor: colors.yellow,
  },
  cardHeader: {
    display: "flex",
    alignItems: "start",
    paddingLeft: "22px",
    paddingRight: "22px",
  },
};
export default CardSliderStyle;
